import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[roleCheck]',
})
export class RoleCheckDirective {
  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
  ) {}

  @Input() set roleCheck(input: { user: any; roles: string[] }) {
    const roles = input.roles;
    const userRoles =
      (input.user && input.user['https://medien-haus.de/roles']) || [];
    console.log(
      '<<<<roleCheck ' +
        JSON.stringify(roles) +
        ' ' +
        JSON.stringify(userRoles),
    );

    if (roles.some((role) => userRoles.includes(role))) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
